export const timeOptions = [
  { id: 1, label: '01:00' },
  { id: 2, label: '02:00' },
  { id: 3, label: '03:00' },
  { id: 4, label: '04:00' },
  { id: 5, label: '05:00' },
  { id: 6, label: '06:00' },
  { id: 7, label: '07:00' },
  { id: 8, label: '08:00' },
  { id: 9, label: '09:00' },
  { id: 10, label: '10:00' },
  { id: 11, label: '11:00' },
  { id: 12, label: '12:00' },
];

export const periodOption = [
  { id: 'AM', label: 'AM' },
  { id: 'PM', label: 'PM' },
];

export const dayLabel = {
  0: 'Sun',
  1: 'Mon',
  2: 'Tue',
  3: 'Wed',
  4: 'Thu',
  5: 'Fri',
  6: 'Sat',
};
